const configMap = {
    baseUrl: process.env.REACT_APP_API_URL
  };
  
  const config = configMap;
  
  export default config;